import * as React from 'react';
import { FormFieldInput } from '@cian/ui-kit';

import * as styles from './styles.css';

export interface IFIOSuggestProps {
  inputValue: string;
  placeholder: React.ReactNode;
  suggestFiltered: React.ReactNode;
  inputRef: React.RefObject<HTMLInputElement> | null;
  error?: string;
  onChange(value: string): void;
  onFocus(): void;
  onKeyDown?(e: React.KeyboardEvent): void;
}

export const FIOSuggest = React.forwardRef<HTMLDivElement, IFIOSuggestProps>((props, ref) => {
  const { onChange, onFocus, inputValue, suggestFiltered, placeholder, inputRef, error, onKeyDown } = props;

  return (
    <div ref={ref} className={styles['container']}>
      <div className={styles['input-container']}>
        <FormFieldInput
          errorMessage={error}
          invalid={Boolean(error)}
          size="M"
          inputRef={inputRef}
          value={inputValue}
          onFocus={onFocus}
          onChange={e => onChange(e.target.value)}
          onKeyDown={onKeyDown}
        />
      </div>
      {placeholder}
      {suggestFiltered}
    </div>
  );
});

FIOSuggest.displayName = 'FIOSuggest';
